var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_962_4691",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_962_4691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.51265 15.834C5.12911 15.834 4.80887 15.7056 4.55192 15.4486C4.29498 15.1917 4.1665 14.8714 4.1665 14.4879V12.5007H4.99984V14.4879C4.99984 14.6161 5.05325 14.7336 5.16009 14.8404C5.26693 14.9473 5.38446 15.0007 5.51265 15.0007H14.487C14.6152 15.0007 14.7327 14.9473 14.8396 14.8404C14.9464 14.7336 14.9998 14.6161 14.9998 14.4879V12.5007H15.8332V14.4879C15.8332 14.8714 15.7047 15.1917 15.4478 15.4486C15.1908 15.7056 14.8706 15.834 14.487 15.834H5.51265ZM9.99984 12.693L7.05111 9.74428L7.64086 9.14493L9.58317 11.0872V3.87891H10.4165V11.0872L12.3588 9.14493L12.9486 9.74428L9.99984 12.693Z",
    fill: "#006DFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.334819bf8cb186261be493f1f2181bcf.svg";
export { ForwardRef as ReactComponent };